module.exports = __webpack_public_path__ + "static/media/EverydayCreativity.7bdea1e4.jpg";